import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserRef, } from '../../core/generated/model/userRef';
import { UserRefControllerService } from '../../core/generated/api/userRefController.service';


@Injectable({
  providedIn: 'root'
})
export class UserRefCacheListService {
  private userRefService = inject(UserRefControllerService);
  private userRefListSubject = new BehaviorSubject<UserRef[] | null>(null);
  private userRefCache: { [cpf: string]: UserRef } = {};

  constructor() {
    const cache = localStorage.getItem('userRefCache');
    if (cache) {
      this.userRefCache = JSON.parse(cache);
    }
  }

  get userRefList$(): Observable<UserRef[] | null> {
    return this.userRefListSubject.asObservable();
  }

  getFromCache(): UserRef[] | null {
    const cache = localStorage.getItem('userRefList');
    return cache ? JSON.parse(cache) : null;
  }

  findUserRefByCpf(cpf: string, callback?: (user: UserRef | undefined) => void): UserRef | undefined {
    if (!cpf) {
      if (callback) callback(undefined);
      return undefined;
    }
    // Busca em memória
    if (this.userRefCache[cpf]) {
      if (callback) callback(this.userRefCache[cpf]);
      return this.userRefCache[cpf];
    }
    // Busca no localStorage
    const cache = localStorage.getItem('userRefCache');
    if (cache) {
      const parsed = JSON.parse(cache);
      if (parsed[cpf]) {
        this.userRefCache[cpf] = parsed[cpf];
        if (callback) callback(parsed[cpf]);
        return parsed[cpf];
      }
    }
    // Busca no backend e adiciona ao cache/localStorage (assíncrono)
    this.userRefService.findDtoByCpf(cpf).subscribe({
      next: (user) => {
        if (user) {
          const userRef = user as any as UserRef;
          this.userRefCache[cpf] = userRef;
          localStorage.setItem('userRefCache', JSON.stringify(this.userRefCache));
          if (callback) callback(userRef);
        } else {
          if (callback) callback(undefined);
        }
      },
      error: () => {
        if (callback) callback(undefined);
      }
    });
    return undefined;
  }
}
